import * as React from 'react';

export interface IUnityPortalProps {
  canvasId: string;
  className?: string;
}

const UnityPortal: React.FC<IUnityPortalProps> = ({ canvasId, className = 'unity-portal' }) => {
  // find container
  const container = document.getElementById(`${canvasId}-container`);
  if (!container) {
    throw new Error('Container for Unity not found on the page!');
  }
  // find canvas
  const canvas = document.getElementById(canvasId);
  if (!canvas) {
    throw new Error('Unity canvas not found on the page!');
  }
  // create portal ref
  const portal = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (portal.current) {
      // move canvas from container to portal
      container.removeChild(canvas);
      portal.current.appendChild(canvas);
    }
    return () => {
      // move canvas back to container
      container.appendChild(canvas);
    };
  });
  return <div ref={portal} className={className} />;
};

export default UnityPortal;
